import React from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import { Cookie } from './utils/Cookies';

import MainPage from './screens/MainPage';
import LoginPanel from './screens/LoginPanel';
import ResetPwd from './screens/ResetPwd';

export default class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      LoginUser : Cookie.get('LoginUser') || '',
    };

    console.log('create app');
  }

  onLogin = (user) => {
    //for test
    Cookie.set('LoginUser', user, { path: '/', maxAge: 7200 });
    this.setState({
      LoginUser : user,
    });
  }

  onLogout = () => {

    Cookie.remove('LoginUser');
    this.setState({
      LoginUser : '',
    });

  }

  renderRoot() {
    const screenProps = {
      onLogin: this.onLogin.bind(this),
      onLogout: this.onLogout.bind(this),
    };

    if(this.state.LoginUser === ''){
      return ( <LoginPanel screenProps={screenProps} /> );
    } else {
      return ( <MainPage screenProps={screenProps} /> );
    }
  }

  render () {
    return (
      <Router>
        <Switch>
          <Route path="/ResetPwd">
            <ResetPwd />
          </Route>
          <Route path="/">
            { this.renderRoot() }
          </Route>
        </Switch>
      </Router>
    );
  }
}
